import React from 'react'
import EndorsementForm from '../../components/EndorsementForm.js'
import StoryForm from '../../components/StoryForm.js'
import Img from 'gatsby-image'
import video1 from '../../img/stories/jessica-foster/Foster_FINAL.mp4'
import videoWebm1 from '../../img/stories/jessica-foster/Foster_FINAL.webm'

import jessicaImg from '../../img/stories/jessica-foster/Jessica_Foster_Frame.jpg'
import yayLogo from '../../img/VoteYay_Long_4C.png'

const jessicaStory = {
  header: `Jessica Foster's Story`,
  headline: `"I'm in disbelief that public school teachers qualify for Habitat for Humanity."`,
  story: [
    {
      text: (
        <div>
          <p>
            Jessica Foster is an elementary school teacher for AISD. Since
            moving to Austin, she has not been able to afford to live close to
            the community she educates.
          </p>
          <p>
            She's lived in cramped, sub-standard apartments that have left her
            housing-cost burdened because of how much of her income she spends
            on rent. There have been times where her car breaks down and she
            can't afford to fix it for months and she's continually struggling
            to make her student loan payments.
          </p>
        </div>
      ),
      media: (
        <div style={{ textAlign: 'center' }}>
          <video controls style={{ width: '100%', border: '3px solid black' }}>
            <source src={video1} type="video/mp4" />
            <source src={videoWebm1} type="video/webm" />
            <p>
              Your browser doesn't support HTML5 video. Here is a{' '}
              <a href={video1}>link to the video</a> instead.
            </p>
          </video>
        </div>
      ),
    },
    {
      text: (
        <div>
          <p>All of this is about to change for Jessica.</p>
          <p>
            Through Austin Habitat for Humanity, Jessica will begin building her
            very own affordable home this November down the street from the
            school she teaches in. She'll get to live in the same community as
            her students, forge deeper bonds with their families, and finally
            make headway on her student debt.
          </p>
        </div>
      ),
      media: '',
    },
    {
      text: (
        <div>
          <p>
            Teachers in Austin would need to make almost double their average
            salary to afford a market-rate home in Austin. We need to invest in
            affordable housing programs now before we push our educators out and
            only upper-income people can afford to live here.
          </p>
          <p>
            The land Jessica's home is being built on was purchased by Austin
            Habitat with the help of City funding -- the type of funding
            Proposition A, the Affordable Housing Bond, will provide.
          </p>
          <p>
            Through the Affordable Housing Bond, we can keep our teachers in
            Austin. We can make an Austin everyone can afford.{' '}
          </p>
        </div>
      ),
      media: <span>todo</span>,
    },
  ],
  callToAction: (
    <div style={{ textAlign: 'center' }}>
      <img
        src={yayLogo}
        alt="Vote Yay for Prop A"
        style={{ maxWidth: '100%', marginBottom: '20px' }}
      />
      <h3>Vote Yay for Prop A on November 6th.</h3>
      <h4>Do it for your neighbors. Do it for teachers like the Jessica.</h4>
    </div>
  ),
}

const JessicFosterStory = props => (
  <StoryTemplate
    header={jessicaStory.header}
    headline={jessicaStory.headline}
    story={jessicaStory.story}
    callToAction={jessicaStory.callToAction}
    primaryImage={props.data.jessicaStory.sizes}
    secondaryImage={props.data.jessicaStory2.sizes}
    thirdImage={props.data.habitat.sizes}
  />
)

const StoryHeader = ({ header, headline, primaryImage }) => (
  <div>
    <h1 className="mb-4">{header}</h1>
    <div className="row align-items-center">
      <div className="col-sm" style={{ textAlign: 'center' }}>
        <video controls style={{ width: '100%', border: '3px solid black' }}>
          <source src={video1} type="video/mp4" />
          <source src={videoWebm1} type="video/webm" />
          <p>
            Your browser doesn't support HTML5 video. Here is a{' '}
            <a href={video1}>link to the video</a> instead.
          </p>
        </video>
      </div>
      <h2 className="col">{headline}</h2>
    </div>
  </div>
)

const StoryTemplate = ({
  header,
  headline,
  body1,
  body2,
  story,
  callToAction,
  primaryImage,
  secondaryImage,
  thirdImage,
}) => {
  return (
    <div className="StoryTemplate container py-4">
      <StoryHeader
        header={header}
        headline={headline}
        primaryImage={primaryImage}
      />
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '4px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm">{story[0].text}</div>
        <div className="col-sm">
          <Img
            title="Father holding infant baby"
            alt="Father holding infant baby"
            sizes={secondaryImage}
            style={{
              width: '100%',
              maxHeight: '90vh',
              border: '3px solid black',
            }}
          />
        </div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm" style={{ textAlign: 'center' }}>
          <Img
            title="Father holding infant baby"
            alt="Father holding infant baby"
            sizes={thirdImage}
            style={{
              width: '100%',
              maxHeight: '90vh',
              border: '3px solid black',
            }}
          />
        </div>
        <div className="col-sm">{story[1].text}</div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm">{story[2].text}</div>
        <div className="col-sm" style={{ textAlign: 'center' }}>
          <Img
            title="Richard Overton, World War II Veteran"
            alt="Richard Overton, World War II Veteran"
            sizes={primaryImage}
            style={{
              width: '100%',
              maxHeight: '90vh',
              border: '3px solid black',
              marginBottom: '20px',
            }}
          />
        </div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row">
        {callToAction}
        <StoryForm />
      </div>
    </div>
  )
}

export default JessicFosterStory

export const query = graphql`
  query JessicaStoryQuery {
    jessicaStory: imageSharp(id: { regex: "/Jessica_Foster_Frame/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    jessicaStory2: imageSharp(id: { regex: "/jessica-teacher/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    habitat: imageSharp(id: { regex: "/jessica-habitat/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/stories/jessica-foster.js